import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, normalizeClass as _normalizeClass, createVNode as _createVNode, withDirectives as _withDirectives, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "_flex" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_avatar = _resolveComponent("skeleton-avatar")
  const _component_base_image = _resolveComponent("base-image")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_openBlock(), _createBlock(_component_tooltip, {
    "info-text": $props.title,
    enabled: $props.title
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (!_ctx.isLoaded)
          ? (_openBlock(), _createBlock(_component_skeleton_avatar, {
              key: 0,
              style: _normalizeStyle({ width: $options.avatarSize + 'px', height: $options.avatarSize + 'px' }),
              class: "gfu-avatar _bgc--light"
            }, null, 8 /* PROPS */, ["style"]))
          : _createCommentVNode("v-if", true),
        _withDirectives(_createVNode(_component_base_image, {
          src: $props.avatarUrl,
          alt: $props.alt,
          width: $options.avatarSize,
          height: $options.avatarSize,
          class: _normalizeClass($options.classNames),
          onLoad: $options.onLoad
        }, null, 8 /* PROPS */, ["src", "alt", "width", "height", "class", "onLoad"]), [
          [_vShow, _ctx.isLoaded]
        ]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3 /* FORWARDED */
  }, 8 /* PROPS */, ["info-text", "enabled"]))
}